import { render, staticRenderFns } from "./InvoicesHomeView.vue?vue&type=template&id=3b930e01&"
import script from "./InvoicesHomeView.vue?vue&type=script&lang=js&"
export * from "./InvoicesHomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports